module.exports = __webpack_public_path__ + "static/media/img7.27728156.jpg";